
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.18 14c-.72 0-3.66 0-4.59-1.54-1.16-2 1.17-3.31 2.2-3.65-.79 0-1.27-.92-1.27-1.73s1.22-1.5 2.23-1.77C3.67 5.1 3 2 6.56 2s5.06.9 5.06 1.64A1.62 1.62 0 019.93 5.1c5.58 2 2.06 3.71.8 3.71 2.18 0 3.55 1.27 3.55 2.56S10.47 14 7.18 14zM4 10.24c-.35.31-.08 1.09.73.81a5.21 5.21 0 012.08-.81 25.41 25.41 0 014.56.16c.35 0 .45-.28 0-.43S7.59 8.87 6 9.22a3.58 3.58 0 00-2 1zm7.31-3.8a5.84 5.84 0 00-1.44-.57A7.36 7.36 0 006.29 6c-.33.08-.25.2 0 .22a17 17 0 013.1.27 11.46 11.46 0 011.39.42c.49.15.84-.29.53-.47zM5.05 3.16A9 9 0 017.19 3a9.89 9.89 0 012 .13c.12 0 .19-.06.07-.1a7 7 0 00-2.16-.46A5.68 5.68 0 005 3c-.12 0-.08.17 0 .15z"}})])
          )
        }
      }
    